import type { Theme } from '@mui/material';

export const styles = {
  footer: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
    px: 0,
    pt: 1,
    pb: 0,
    marginTop: 'auto',

    [theme.breakpoints.down('lg')]: {
      padding: 2,
      mt: 0,
      mr: -3.5,
      mb: -2.25,
      ml: -4,
    },
  }),

  footerButton: (theme: Theme) => ({
    minWidth: '0',
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '0.1rem 0',
    color: theme.colors.neutral[800],

    '&:hover': {
      textDecoration: 'underline',
      background: 'none',
    },
  }),

  footerClaim: (theme: Theme) => ({
    marginTop: '0.8rem',
    fontSize: '0.8rem',
    color: theme.colors.neutral[500],
    textAlign: 'center',
  }),
};
